<div class="mod-approval-timeout page-container" *ngIf="canView()">
  <p-toast />
  <div class="page-header">
    <h2>{{ 'modification_approval_timeout.title' | translate }}</h2>
    <p class="subtitle">
      {{ 'modification_approval_timeout.subtitle' | translate }}
    </p>
  </div>

  <div class="form-card" [class.loading]="loading()">
    <div class="field">
      <label for="timeoutMinutes">
        {{ 'modification_approval_timeout.fields.timeout_minutes' | translate }}
      </label>
      <p-inputNumber
        inputId="timeoutMinutes"
        [ngModel]="timeoutMinutes()"
        (ngModelChange)="timeoutMinutes.set($event)"
        [min]="1"
        [max]="10080"
        [disabled]="!canEdit() || loading() || saving()"
        [showButtons]="true"
      />
    </div>

    <div class="field row">
      <label for="enabled">
        {{ 'modification_approval_timeout.fields.enabled' | translate }}
      </label>
      <p-toggleswitch
        inputId="enabled"
        [ngModel]="enabled()"
        (ngModelChange)="enabled.set($event)"
        [disabled]="!canEdit() || loading() || saving()"
      />
    </div>

    <div class="actions" *ngIf="canEdit()">
      <app-button
        [label]="'common.actions.save' | translate"
        severity="info"
        [loading]="saving()"
        [disabled]="loading()"
        (emitOnClick)="save()"
      />
    </div>
  </div>
</div>
